import FormattedMessage from 'I18n/components/FormattedMessage';
import { TypeaheadResultsItem } from 'foundations-components/transitional/components/Typeahead';
import { INPUT_WIDTHS_FOR_THREE_INPUTS_WITH_BULLET_POINT, LABEL_WIDTHS } from '../../constants/inlineLayout';
import FilterOperatorErrorRecord from '../../filterQueryFormat/FilterOperatorErrorRecord';
import { Text } from 'foundations-components/components/Text';
import { isOperator } from '../../filterQueryFormat/operator/Operator';
import { useConditionInputs } from '../../hooks/useConditionInputs';
import { useEditorActions } from '../../hooks/useEditorActions';
import { MEDIA_SIZES, useElementSize } from '../../hooks/useElementSize';
import { usePropertyChangedNameAndValueFilter } from '../../hooks/usePropertyChangedNameAndValueFilter';
import { useStrategy } from '../../hooks/useStrategy';
import ConditionBox from '../common/ConditionBox';
import ConditionError from '../common/ConditionError';
import InlineContainerWithEditorConditionActions from '../common/InlineContainerWithEditorConditionActions';
import FilterOperatorPropertyInput from '../operator/FilterOperatorPropertyInput';
import UpdateFilterWithExternalOptionsNotification from '../operator/UpdateFilterWithExternalOptionsNotification';
import EditorConditionValueInput from './EditorConditionValueInput';
import EditorIncludeObjectsWithNoValueSetInput from './EditorIncludeObjectsWithNoValueSetInput';
import EditorPropertyNameAndValueCondition from './EditorPropertyNameAndValueCondition';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorPropertyNameAndValueConditionResponsive = props => {
  const {
    condition,
    conditionPath,
    filterFamily,
    getIsUngated,
    inputUse,
    isNested
  } = props;
  const {
    width
  } = useElementSize();
  const {
    getValueResolver,
    isIncludeObjectsWithNoValueSetCheckboxEnabled
  } = useStrategy();
  const {
    hydratedCondition,
    onPropertyNameChange,
    onPropertyValueOperatorChange,
    onPropertyValueValueChange
  } = usePropertyChangedNameAndValueFilter(filterFamily, condition, conditionPath);
  const {
    onConditionDelete
  } = useEditorActions();
  const resolver = getValueResolver(hydratedCondition.referencedObjectTypeId, hydratedCondition);
  const propertyValueCondition = isOperator(hydratedCondition === null || hydratedCondition === void 0 ? void 0 : hydratedCondition.propertyValue) ? hydratedCondition === null || hydratedCondition === void 0 ? void 0 : hydratedCondition.propertyValue : undefined;
  const {
    canFilterBeConverted,
    disableOperatorSelection,
    disableValueInput,
    handleUpdateClick,
    isOperatorIncompatible,
    onSelectedOptionChange,
    operatorOptions
  } = useConditionInputs({
    condition: propertyValueCondition,
    filterFamily,
    onConditionOperatorChange: onPropertyValueOperatorChange,
    onConditionValueChange: onPropertyValueValueChange
  });
  if (!hydratedCondition || !hydratedCondition.referencedObjectTypeId) {
    return null;
  }
  if (width.size === MEDIA_SIZES.sm) {
    return /*#__PURE__*/_jsx(EditorPropertyNameAndValueCondition, Object.assign({}, props));
  }
  const objectTypeId = typeof hydratedCondition.referencedObjectTypeId === 'string' ? hydratedCondition.referencedObjectTypeId : undefined;
  return /*#__PURE__*/_jsxs(ConditionBox, {
    isNestedOrHeader: isNested,
    children: [/*#__PURE__*/_jsxs(InlineContainerWithEditorConditionActions, {
      condition: hydratedCondition,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      onConditionDelete: () => onConditionDelete(conditionPath),
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: LABEL_WIDTHS[width.size]
        },
        children: /*#__PURE__*/_jsx(FilterOperatorPropertyInput, {
          condition: hydratedCondition,
          error: FilterOperatorErrorRecord(),
          onChange: onPropertyNameChange,
          resolver: resolver,
          fieldName: "propertyName",
          getIsUngated: getIsUngated,
          inputUse: inputUse
        })
      }), !!propertyValueCondition && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            maxWidth: INPUT_WIDTHS_FOR_THREE_INPUTS_WITH_BULLET_POINT[width.size]
          },
          children: /*#__PURE__*/_jsx(Text, {
            as: "h6",
            marginBlockEnd: "0",
            textTransform: "uppercase",
            color: "icon-core-subtle",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "customerDataFiltersUI.propertyValueChangedEvent.editorPropertyNewValue"
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          style: {
            alignSelf: 'start',
            flexShrink: 0,
            width: `${INPUT_WIDTHS_FOR_THREE_INPUTS_WITH_BULLET_POINT[width.size]}px`
          },
          children: /*#__PURE__*/_jsx(Select, {
            "data-onboarding": "filter-condition-select-field",
            "data-selenium-test": "fr-filter-operator-select",
            "data-test-id": "fr-filter-operator-select",
            disabled: disableOperatorSelection,
            onSelectedOptionChange: onSelectedOptionChange,
            optionRenderer: option => /*#__PURE__*/_jsx(TypeaheadResultsItem, {
              message: true,
              option: option
            }),
            options: operatorOptions,
            readOnly: operatorOptions.length === 1,
            value: propertyValueCondition.constructor.toString(),
            buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined
          })
        }), /*#__PURE__*/_jsx("div", {
          style: {
            alignSelf: 'start',
            minWidth: `${INPUT_WIDTHS_FOR_THREE_INPUTS_WITH_BULLET_POINT[width.size]}px`
          },
          children: /*#__PURE__*/_jsx(EditorConditionValueInput, {
            inputUse: inputUse,
            condition: propertyValueCondition,
            disabled: disableValueInput,
            filterFamily: objectTypeId || filterFamily,
            onChange: onPropertyValueValueChange
          })
        })]
      })]
    }), !!propertyValueCondition && /*#__PURE__*/_jsxs(_Fragment, {
      children: [isIncludeObjectsWithNoValueSetCheckboxEnabled && /*#__PURE__*/_jsx(EditorIncludeObjectsWithNoValueSetInput, {
        condition: propertyValueCondition,
        conditionPath: conditionPath
        // @ts-expect-error doesn't know that `referencedObjectTypeId` is guaranteed in `hydratedCondition`
        ,
        filterFamily: hydratedCondition.referencedObjectTypeId,
        onChange: onPropertyValueValueChange,
        spaceStyleProps: {
          marginBlockStart: '200'
        }
      }), isOperatorIncompatible && /*#__PURE__*/_jsx(UpdateFilterWithExternalOptionsNotification, {
        onUpdateClick: handleUpdateClick,
        canFilterBeConverted: canFilterBeConverted
      }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
        condition: propertyValueCondition
      }), /*#__PURE__*/_jsx(ConditionError, {
        condition: propertyValueCondition
      })]
    })]
  });
};
export default EditorPropertyNameAndValueConditionResponsive;